module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-31.4abfd6bf.jpg";